import React from "react";
import { DemoForm } from "./Components/DemoForm";
import { useHistory } from "react-router-dom";
import Page from "../UI/Elements/Page";
import { Box } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    minHeight: 'calc(100vh - 314px)',
    padding: '3.5rem 1.25rem 4rem',
    // background:
    //   'radial-gradient(circle at 16% 20%, rgba(93, 173, 226, 0.28), transparent 55%),' +
    //   'radial-gradient(circle at 82% 18%, rgba(255, 107, 107, 0.30), transparent 54%),' +
    //   'radial-gradient(circle at 78% 86%, rgba(61, 30, 92, 0.14), transparent 58%),' +
    //   'linear-gradient(180deg, #F2F7FF 0%, #FFF8F0 100%)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: '2.5rem 0.75rem 3rem',
    },
  },
  paper: {
    padding: '4rem',
    borderRadius: '30px',
    margin: 'auto',
    maxWidth: '80%',
    backgroundColor: 'rgba(255, 255, 255, 0.86)',
    backdropFilter: 'blur(10px) saturate(140%)',
    WebkitBackdropFilter: 'blur(10px) saturate(140%)',
    border: '1px solid rgba(255, 255, 255, 0.65)',
    boxShadow: '0 24px 60px rgba(61, 30, 92, 0.10)',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
      padding: '3rem',
   },
  },
  actionButton: {
    margin: '1rem 0'
  }
}));

const Demo = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.root}>
      <Page>
        <Paper className={classes.paper}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <h1>Benieuwd hoe AllesBon werkt?</h1> 
              <h3>Boek vandaag nog je gratis demo!</h3>
              <Box my={4}>
                <p>Vul je gegevens in en laat eventueel een opmerking of je gewenste datum/tijdstip achter. Wij contacteren je dan zo snel mogelijk om een online demo of bij jou ter plekken in te plannen.</p>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <DemoForm onClose={() => history.go(0)}/>
            </Grid>
          </Grid>
        </Paper>
      </Page>
    </div>
  );
};

export default Demo;
